export default __webpack_public_path__ + "static/media/standard.cd6b0b18.png";